/**
 * Owner-admin API client for ingest review surfaces.
 * Talks to /api/admin/v2/ingest/* — superuser-only per backend
 * IsSuperuser permission.
 */
import api from "./axios";

const BASE = "/api/admin/v2/ingest";

// ── Review queue (N3) ─────────────────────────────────────────────────

export const listReviewItems = (params = {}) =>
  api.get(`${BASE}/review-items/`, { params });

export const resolveReviewItem = (id, resolvedValue) =>
  api.post(`${BASE}/review-items/${id}/resolve/`, { resolved_value: resolvedValue });

export const skipReviewItem = (id) =>
  api.post(`${BASE}/review-items/${id}/skip/`);

export const bulkSkipReviewItems = (ids) =>
  api.post(`${BASE}/review-items/bulk-skip/`, { ids });

// ── Anomalies (N4) ────────────────────────────────────────────────────

export const listAnomalies = (params = {}) =>
  api.get(`${BASE}/anomalies/`, { params });

export const bulkResolveAnomalies = (ids) =>
  api.post(`${BASE}/anomalies/bulk-resolve/`, { ids });

export const bulkIgnoreAnomalies = (ids) =>
  api.post(`${BASE}/anomalies/bulk-ignore/`, { ids });

// ── Coverage (N5) ─────────────────────────────────────────────────────

export const getCoverageDashboard = () =>
  api.get(`${BASE}/coverage/`);

// ── Player ingest review ─────────────────────────────────────────────

export const listPlayerCountries = () =>
  api.get(`${BASE}/players/countries/`);

// 2026-07-09 — batch-delete every SYSTEM-owned Player under a country
// (skips linked_user + in-use rows). Discards any PLAYER_PROFILE
// IngestJob whose filename mentions the country name. Backend returns
// counts + in_use_samples.
export const deletePlayerCountryBatch = (code) =>
  api.delete(`${BASE}/players/countries/${encodeURIComponent(code)}/`);

export const listPlayerCandidates = (params = {}) =>
  api.get(`${BASE}/players/candidates/`, { params });

export const decidePlayerCandidate = (id, body) =>
  api.post(`${BASE}/players/candidates/${id}/decide/`, body);

export const listPlayerIngestUploads = (params = {}) =>
  api.get(`${BASE}/players/uploads/`, { params });

export const deletePlayerIngestUpload = (jobId) =>
  api.delete(`${BASE}/players/uploads/${jobId}/`);

export const listPlayerOwners = () =>
  api.get(`${BASE}/players/owners/`);
